import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { selectUserProfile } from '@Header/ducks/selectors';
import { connect } from 'react-redux';

const ImpersonationContainer = styled.div.attrs({ role: 'status' })`
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.carvana.impersonationRed};
  font-size: 30px;
  color: ${props => props.theme.carvana.white.primary};
  text-align: center;
  z-index: 150;
`;

const Message = styled.span`
  margin-right: 10px;
`;

const Impersonation = ({ profile }) => (
  <ImpersonationContainer>
    <Message>

      Currently Impersonating User:
      {' '}
      {profile?.profileFirstName}
      {' '}
      {profile?.profileLastName}
    </Message>
    <a
      href={`/manageuser/deimpersonate?i=userdetails&returnUrl=/managecustomer?userid=${profile.userId}`}
      target="_self"
      aria-label="stop impersonating"
    >Stop
    </a>
  </ImpersonationContainer>
);

Impersonation.propTypes = {
  profile: PropTypes.shape({
    profileFirstName: PropTypes.string.isRequired,
    profileLastName: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  profile: selectUserProfile(state)
});

export default connect(mapStateToProps)(Impersonation);
